// let sessionData = [];
//
// const sessionItems = sessionStorage.getItem('items');
//
// if (sessionItems !== null) {
//   sessionData = JSON.parse(sessionItems);
// }

export default {
  data: {
    savedItems: [],
  },
};
